import React, {useEffect, useRef, useState} from "react";

export const ManualScrollWrapperComposer = (ManualScrollWrapper) => ((props) => {
  const containerRef = useRef(null);
  const [containerHeight, setContainerHeight] = useState(0);
  const [offset, setOffset] = useState(null);
  const [position, setPosition] = useState(0);

  useEffect(() => {handleContentResize()}, []);

  const handleContentResize = () => {
    const height = containerRef?.current.clientHeight;
    const childHeight = containerRef?.current.scrollHeight;

    setContainerHeight(height);
    setOffset(-(childHeight - height));
  }

  const onUpClick = () => {
    if (position < 0) {
      const diff = position + (containerHeight)
      const newPosition = diff < 0 ? diff : 0
      setPosition(newPosition)
    }
  }

  const onDownClick = () => {
    if (position > offset) {
      const diff = position - (containerHeight)
      const newPosition = diff < offset ? offset : diff
      setPosition(newPosition)
    }
  }

  const newProps = {
    ref: containerRef,
    position: position,
    offset: offset,
    isUpScrollAllow: position < 0,
    isDownScrollAllow: position > offset,
    shouldRenderArrows: offset < 0,
    onUpClick: () => onUpClick(),
    onDownClick: () => onDownClick(),
    handleContentResize: () => handleContentResize(),
    ...props
  };

  return (
    <ManualScrollWrapper {...newProps} />
  );
});
